import { Component, OnInit, OnDestroy } from '@angular/core';
import { WebService } from '../../services/web/web.service'; // o dove sta il tuo WebService
import { Router } from '@angular/router';
import { TemaService } from 'src/app/services/tema/tema.service';
import { interval, of, Subscription } from 'rxjs';
import { switchMap, catchError, startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-manutenzione',
  templateUrl: './manutenzione.component.html',
  styleUrls: ['./manutenzione.component.scss'],
})
export class ManutenzioneComponent implements OnInit, OnDestroy {
  public logoPath: string = '';
  public bgPath: string = '';
  public isGo = false;

  private readonly checkInterval = 30000;
  private subscription?: Subscription;

  constructor(
    private readonly webService: WebService,
    private readonly router: Router,
    private readonly temaService: TemaService,
  ) {}

  ngOnInit(): void {
    this.temaService.temaUpdated.subscribe(() => {
      this.logoPath = this.temaService.logoPath;
      this.bgPath = this.temaService.bgPath;
    });

    this.subscription = interval(this.checkInterval)
      .pipe(
        startWith(0),
        switchMap(() =>
          this.webService.doGet('/admin/maintenance/status', {}, false).pipe(
            map((response) => response.maintenance),
            catchError(() => of(true)), // Se errore assumiamo ancora manutenzione attiva
          ),
        ),
      )
      .subscribe((maintenanceActive) => {
        if (!maintenanceActive) {
          // Se manutenzione non attiva, vai alla login
          this.router.navigate(['/login']);
        }
        // Altrimenti rimani sulla pagina manutenzione
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
